"use client";

import React from "react";
import { Scroll, ShieldPlus, FileText, Scale, HeartPulse, UserCheck, Briefcase } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const coreDocuments = [{
  title: "Wills in Probate",
  description: "A Last Will and Testament may identify beneficiaries of probate assets and nominate a Personal Representative. Questions may arise concerning the original Will, competing versions, interpretation, execution, validity, or its treatment in a probate proceeding.",
  icon: Scroll
}, {
  title: "Trust Administration",
  description: "Trust-related matters may involve reviewing the trust instrument, identifying trustees and beneficiaries, administering trust property, interpreting provisions, addressing requests for information, and resolving questions concerning distributions or fiduciary responsibilities.",
  icon: ShieldPlus
}, {
  title: "Beneficiary and Heir Issues",
  description: "Questions may arise concerning who is entitled to receive property, whether an interest passes under a Will, trust, beneficiary designation, ownership arrangement, or Florida intestacy law.",
  icon: UserCheck
}, {
  title: "Personal Representative and Trustee Responsibilities",
  description: "A Personal Representative or trustee may have duties involving asset identification, recordkeeping, notices, expenses, claims, distributions, and communication with interested persons.",
  icon: HeartPulse
}, {
  title: "Probate and Trust Disputes",
  description: "Disputes may involve the validity or interpretation of a Will or trust, fiduciary conduct, beneficiary rights, asset ownership, accountings, distributions, or other administration issues.",
  icon: FileText
}, {
  title: "Estate and Trust Assets",
  description: "Real estate, financial accounts, business interests, personal property, debts, liens, and beneficiary designations may require review to determine how an asset should be administered or transferred.",
  icon: Scale
}];
export default function CoreEstateDocuments() {
  return <section id="coreestatedocuments" className="bg-background py-20 md:py-28 lg:py-32">
      <div className="container mx-auto max-w-6xl px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-serif text-primary mb-4 text-3xl font-semibold tracking-tight md:text-4xl lg:text-5xl">Common Will, Trust, and Probate Matters</h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg leading-relaxed">The issues involved depend on the governing documents, ownership arrangements, beneficiaries, assets, debts, and procedural history of the matter.</p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {coreDocuments.map((doc, i) => <Card key={i} data-index={i} className="border-border/50 bg-card p-6 shadow-sm transition-shadow hover:shadow-md">
              <CardHeader className="p-0 pb-4">
                <div className="bg-secondary/10 mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg">
                  <doc.icon className="text-secondary h-6 w-6" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-serif text-primary text-xl">
                  {doc.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {doc.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground/80 text-sm italic">Note: The office does not provide estate-planning, will-drafting, power-of-attorney, health-care-directive, or lifetime asset-planning services.</p>
        </div>
      </div>
    </section>;
}